import {userService} from '../services/user.services';

export const fetchUserData = (data ) => dispatch => {

    let userData = userService.getAllUsers(data);
    userData.then(userData => {
        dispatch({
            type: "USER_DATA_SUCCESS",
            userData
        });
    });
}
export const searchUser = ( data ) => dispatch => {

    let filteredData = data.userListData;
    let searchvalue = data.search_text;
    if(searchvalue !== '') {
        filteredData = filteredData.filter(
            item => item.name.toLowerCase().search(searchvalue.toLowerCase()) >= 0
        )
    }

    if(data.sort === 'new') {
        filteredData.sort(function(a, b){
            return b.id-a.id
        });
    }
    else if(data.sort === 'old') {
        filteredData.sort(function(a, b){
            return a.id-b.id
        });
    }
    else if(data.sort === 'az') {
        filteredData.sort(function(a, b){
            if(a.name !== undefined && b.name !== undefined && a.name !== null && b.name !== null) {
                var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }
    else if(data.sort === 'za') {
        filteredData.sort(function(a, b){
            if(a.name !== undefined && b.name !== undefined && a.name !== null && b.name !== null) {
                var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
                if (nameA > nameB) //sort string ascending
                    return -1
                if (nameA < nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }

    console.log(filteredData);
    dispatch({
        type: "USER_DATA_SEARCH_SUCCESS",
        filteredData : filteredData,
        searchText : data.search_text,
        sort : data.sort,
        userid : data.userid

    });
}
export const createUser = (data ) => dispatch => {

    let created = userService.createUser(data);

    created.then(created => {
        dispatch({
            type: "CREATE_USER",
            created
        });
    });
}


// WEBPACK FOOTER //
// ./src/actions/user.js